import { createContext, useContext, useEffect, useMemo, type ReactNode } from 'react';
import { MESSAGES, type Language, type Messages } from './messages';

const LanguageContext = createContext<{ language: Language; t: Messages }>({
  language: 'uk',
  t: MESSAGES.uk,
});

/**
 * DE: Stellt Sprache und Texte bereit und setzt das `lang`-Attribut der Seite.
 * EN: Provides language and texts and sets the page's `lang` attribute.
 */
export function LanguageProvider({
  language,
  children,
}: {
  language: Language;
  children: ReactNode;
}) {
  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);
  const value = useMemo(() => ({ language, t: MESSAGES[language] }), [language]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

/**
 * DE: Aktuelle Sprache und ihre Texte.
 * EN: Current language and its texts.
 */
export function useMessages(): { language: Language; t: Messages } {
  return useContext(LanguageContext);
}
